import { Errors, filterErrors } from 'lib/validationWatcher';

// Keep in sync w/ server-side value in PortCall.EndPoints\Infra\AgentRestrictions\AgentRestrictionConstants.cs
export const AGENT_RESTRICTIONS_VALIDATION_PREFIX = "agent-restriction-";

/**
 * Filter an errors dictionary to just errors representing violations of agent restrictions.
 */
export function agentRestrictionErrors(errors : Errors) {
    return filterErrors(errors, key => key.indexOf(AGENT_RESTRICTIONS_VALIDATION_PREFIX) === 0);
}



// WEBPACK FOOTER //
// ./apps/common/services/agentRestrictionsErrorParser.ts